export const TRACKER = 'M322.621,42.825C294.073,14.272,259.619,0,219.268,0c-40.353,0-74.803,14.275-103.353,42.825c-28.549,28.549-42.825,63-42.825,103.353c0,20.749,3.14,37.782,9.419,51.106l104.21,220.986c2.856,6.276,7.283,11.225,13.278,14.838c5.996,3.617,12.419,5.428,19.273,5.428c6.852,0,13.278-1.811,19.273-5.428c5.996-3.613,10.513-8.562,13.559-14.838l103.918-220.986c6.282-13.324,9.424-30.358,9.424-51.106C365.449,105.825,351.176,71.378,322.621,42.825z M270.942,197.855c-14.273,14.272-31.497,21.411-51.674,21.411s-37.401-7.139-51.678-21.411c-14.275-14.277-21.414-31.501-21.414-51.678c0-20.175,7.139-37.402,21.414-51.675c14.277-14.275,31.504-21.414,51.678-21.414c20.177,0,37.401,7.139,51.674,21.414c14.274,14.272,21.413,31.5,21.413,51.675C292.355,166.352,285.217,183.575,270.942,197.855z';
export const TRIP_START = 'M12,5c-3.859,0-7,3.141-7,7s3.141,7,7,7s7-3.141,7-7S15.859,5,12,5z M12,17c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5 S14.757,17,12,17zM12,9c-1.627,0-3,1.373-3,3s1.373,3,3,3s3-1.373,3-3S13.627,9,12,9z';
export const EVENT = 'M12,2C6.486,2,2,6.486,2,12s4.486,10,10,10s10-4.486,10-10S17.514,2,12,2z M13,17h-2v-6h2V17z M13,9h-2V7h2V9z';
export const LANDMARK = 'M4.236,25.127V4.897M5.236,25.127V4.897M5.529,5.871c4.866,2.085,7.23,1.947,12.375,0.139c-1.46,2.92-1.46,5.145,0,8.064c-5.006,1.738-7.021,1.738-12.375,0V5.871z';
export const TRIP_FINISH = 'M19 4H6V2H4v18H3v2h4v-2H6v-5h13a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z';
export const TRUCK = 'M541.322,500.219v-94.372c0-20.277-16.438-36.716-36.715-36.716h-9.598V24.598c0-3.082-1.547-5.958-4.117-7.657\n' +
    '\t\tL467.587,1.537c-6.103-4.033-14.239,0.342-14.239,7.657v110.652l-6.945-18.734c-9.34-25.196-33.373-41.918-60.245-41.918H225.702\n' +
    '\t\tc-27.03,0-51.169,16.916-60.394,42.323l-6.655,18.329V9.194c0-7.314-8.137-11.69-14.24-7.657L121.107,16.94\n' +
    '\t\tc-2.571,1.699-4.118,4.575-4.118,7.657v344.534h-9.597c-20.277,0-36.715,16.438-36.715,36.716v94.372H55.035\n' +
    '\t\tc-5.069,0-9.178,4.109-9.178,9.179v50.743c0,5.069,4.109,9.179,9.178,9.179h39.598v24.322c0,10.139,8.219,18.357,18.358,18.357\n' +
    '\t\th48.645c10.139,0,18.358-8.219,18.358-18.357V569.32h252.014v24.322c0,10.139,8.22,18.357,18.357,18.357h48.646\n' +
    '\t\tc10.139,0,18.357-8.219,18.357-18.357V569.32h39.598c5.07,0,9.179-4.11,9.179-9.179v-50.742c0-5.07-4.109-9.179-9.179-9.179\n' +
    '\t\tL541.322,500.219L541.322,500.219z M170.814,170.975h270.372v90.44H170.814V170.975z M164.527,474.533H133.17\n' +
    '\t\tc-9.581,0-17.348-7.768-17.348-17.349v-0.438c0-9.581,7.767-17.348,17.348-17.348h31.356c9.581,0,17.348,7.767,17.348,17.348v0.438\n' +
    '\t\tC181.875,466.765,174.108,474.533,164.527,474.533z M368.398,479.648H243.602c-10.139,0-18.358-8.22-18.358-18.357V344.976\n' +
    '\t\tc0-10.138,8.219-18.357,18.358-18.357h124.796c10.138,0,18.357,8.22,18.357,18.357v116.314\n' +
    '\t\tC386.756,471.428,378.536,479.648,368.398,479.648z M478.829,474.533h-31.356c-9.58,0-17.348-7.768-17.348-17.349v-0.438\n' +
    '\t\tc0-9.581,7.768-17.348,17.348-17.348h31.356c9.581,0,17.349,7.767,17.349,17.348v0.438\n' +
    '\t\tC496.178,466.765,488.41,474.533,478.829,474.533z M365.607,393.801H246.099c-5.019,0-9.087-4.068-9.087-9.088v-0.184\n' +
    '\t\tc0-5.019,4.068-9.086,9.087-9.086h119.508c5.019,0,9.087,4.067,9.087,9.086v0.184C374.694,389.733,370.626,393.801,365.607,393.801\n' +
    '\t\tz M365.607,357.085H246.099c-5.019,0-9.087-4.068-9.087-9.087v-0.184c0-5.018,4.068-9.086,9.087-9.086h119.508\n' +
    '\t\tc5.019,0,9.087,4.068,9.087,9.086v0.184C374.694,353.017,370.626,357.085,365.607,357.085z M365.607,467.232H246.099\n' +
    '\t\tc-5.019,0-9.087-4.068-9.087-9.087v-0.184c0-5.019,4.068-9.087,9.087-9.087h119.508c5.019,0,9.087,4.068,9.087,9.087v0.184\n' +
    '\t\tC374.694,463.164,370.626,467.232,365.607,467.232z M365.607,430.516H246.099c-5.019,0-9.087-4.068-9.087-9.086v-0.184\n' +
    '\t\tc0-5.019,4.068-9.087,9.087-9.087h119.508c5.019,0,9.087,4.068,9.087,9.087v0.184C374.694,426.448,370.626,430.516,365.607,430.516\n' +
    '\t\tz';

export const CUSTOM_ASSET_1 = `
<svg xmlns="http://www.w3.org/2000/svg"
     width="38" height="64" viewBox="0 0 38 64">
  <defs>
    <radialGradient id="silverGrad" cx="50%" cy="50%" r="50%">
      <stop offset="0%"   stop-color="#ffffff"/>
      <stop offset="100%" stop-color="#c0c0c0"/>
    </radialGradient>
  </defs>

  <!-- silver disc -->
  <path
    d="M19,17
       A15,15 0 1,0 19,47
       A15,15 0 1,0 19,17 Z"
    fill="url(#silverGrad)"
  />

  <!-- grey plate -->
  <path
    d="M16,5 h7 v17 h-7 Z"
    fill="#7b7b7b"
  />

  <!-- dark accent -->
  <path
    d="M18,6 h1 v3 h-1 Z"
    fill="#3c1f2f"
  />

  <!-- red pill -->
  <path
    d="M19,6 h1 v3 h-1 Z"
    fill="#e74c3c"
  />
</svg>`;

export const CUSTOM_ASSET_2 = `
<svg xmlns="http://www.w3.org/2000/svg" width="38" height="64" viewBox="0 0 64 64">
  <path d="M8,32 C8,24 24,16 32,16 C40,16 56,24 56,32 L56,40 C56,44 52,48 48,48 L16,48 C12,48 8,44 8,40 Z"
        fill="#FFD600" stroke="#333333" stroke-width="4"/>
  <rect x="4" y="40" width="56" height="8"
        fill="#FFD600" stroke="#333333" stroke-width="4"/>
</svg>
`;